import { NotificationEventName } from '@models/notifications/notificationEventTypeNames.enum';

export class Notification {
  id: number;
  isRead: boolean;
  message: string;
  title: string;
  type: NotificationEventName;
  convId: number;
  userId: number;
  taskId: number;
  supportTicketUid: string;
  hasMore: boolean;
  notifications: [];
  task: {
    title?: string;
    city?: string;
  };
  createdAt: string;
  updatedAt: string;

  constructor(data: any = null) {
    Object.assign(this, data);
  }
}
